interface EnvironmentConfig {
  isDevelopment: boolean;
  isProduction: boolean;
  apiBase: string;
  googleClientId: string;
  appVersion: string;
  buildTime: string;
}

function validateEnvironment(): EnvironmentConfig {
  const isDevelopment = import.meta.env.DEV;
  const isProduction = import.meta.env.PROD;
  
  // Required environment variables
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string;
  
  // Optional environment variables with defaults
  const apiBase = import.meta.env.VITE_API_BASE as string || '/api';
  const appVersion = import.meta.env.VITE_APP_VERSION as string || '0.1.0';
  const buildTime = import.meta.env.VITE_BUILD_TIME as string || new Date().toISOString();

  // Validation warnings
  if (!googleClientId && isProduction) {
    console.warn('VITE_GOOGLE_CLIENT_ID is not defined. Google Sign-In will not work in production.');
  }

  return {
    isDevelopment,
    isProduction,
    apiBase,
    googleClientId: googleClientId || '',
    appVersion,
    buildTime
  };
}

export const env = validateEnvironment();

// Export individual values for convenience
export const {
  isDevelopment,
  isProduction,
  apiBase,
  googleClientId,
  appVersion,
  buildTime
} = env; 